import { render, staticRenderFns } from "./userPoints.vue?vue&type=template&id=35636450"
import script from "./userPoints.vue?vue&type=script&lang=js"
export * from "./userPoints.vue?vue&type=script&lang=js"
import style0 from "./userPoints.vue?vue&type=style&index=0&id=35636450&prod&module=scss&lang=css"




function injectStyles (context) {
  
  this["scss"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports